<!-- "components tags" are not recognised by the Browser, so it sets the default display value = 'inline' for the host element -->
<!-- in order to solve height issues, we set the component's main div display: block -->
<!-- see: https://nitayneeman.com/posts/solving-a-styling-issue-for-rendered-components-in-angular/ -->

<div class="container-fluid" style="display: block; height: 100%; width: 100%;">

  <div class="row no-gutters">
    <div class="col-12">

      <ul id="tabsList" class="tabs-x">
        <li *ngFor="let item of tabsList; let i = index"
            [style.flex]="rank ? '0 0 calc(100% / ' + rank + ' - ( 15px / ' + rank +')' : ''"
            [style.min-width]="rank ? 'calc(100% / ' + rank + ' - ( 15px / ' + rank +')' : ''"
            [ngClass]="{'selectedtab':item?.isSelected}"
            (click)="tabClick(i, item)">
          <div>
            <img *ngIf="item.img" class="tabs-img" [attr.src]="item.img" />
            <span class="tabs-span">{{item.title}} <span class="badge badge-secondary c-badge" [ngClass]="{'c-badgesel':item.isSelected}">{{item.itemNumber}}</span></span>
          </div>
        </li>
        <li *ngIf="boModel && boModel?.IdDonneeFils && boModel?.IdDonneeFils != '0' && indParam.AppParams.LoggedUser.Ident == '1389' && showConfig" class="q-text-s config" (click)="OpenConfig()">
          <div title="Éditer la segmentation">
            <span class="fa-stack">
              <i class="q-c-main fas fa-ruler-combined fa-stack-1x fa-lg" style="bottom: 0px; left: -3px;"></i>
              <i class="q-c-secondary fas fa-pencil-alt fa-stack-1x" style="top: -2px; left: 4px;"></i>
              <i class="q-c-secondary fas fa-ruler-horizontal fa-stack-1x fa-lg" style="bottom: -11px; left: 2px;"></i>
            </span>
          </div>
        </li>

      </ul>

    </div>
  </div>

  <div class="row no-gutters mt-3">
    <div class="col-12">
      <div *ngIf="loadComponent">
        <q-customgrid *ngIf="model?.component === 'grid'" [activeButton]="model.activeButton" [customgridName]="''" [customgridParam]="model.model" [customgridHeightOffset]="gridOffset" [(refreshData)]="refreshData"></q-customgrid>
        <q-bodisplay *ngIf="model?.component === 'bo'" [modeBo]="modeBo.Edit" [item]="model.model" [globalsave]="false" [saveAfter]="false" (sendEvent)="getEvent($event)"></q-bodisplay>
      </div>
    </div>
  </div>

</div>


<!--#region modal -->
<ng-template #ModalSegmentation let-modalSegmentation>
  <div #header class="modal-header">
    <h5 class="modal-title" id="exampleModalLongTitle"></h5>
    <button type="button" class="close" aria-label="Close" (click)="modalSegmentation.close('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div *ngIf="showModal" class="modal-body overflow-auto" [style.height]="sanitizer.bypassSecurityTrustStyle('calc(100% - ' + header.offsetHeight + 'px)')">
    <q-segmentation *ngIf="breadcrumb.link === 'q-segmentation'" [item]="breadcrumb.data.model"></q-segmentation>
    <q-insertdoc *ngIf="breadcrumb.link === 'q-insertdoc'" [item]="breadcrumb.data.model" [registerMode]="registerModeLink"></q-insertdoc>
    <q-customgrid *ngIf="breadcrumb.link === 'q-customgrid'" [activeButton]="" [customgridName]="''" [customgridParam]="breadcrumb.data.model"></q-customgrid>
    <q-bodisplay *ngIf="breadcrumb.link === 'q-bodisplay'" [globalsave]="false" [item]="breadcrumb.data.model" (sendEvent)="getEvent($event, modalSegmentation)"></q-bodisplay>
    <q-search *ngIf="breadcrumb.link === 'q-search'" [idBo]="breadcrumb.data.model.IdentBO" [codeRelation]="breadcrumb.data.model.IdRelation" [idPere]="breadcrumb.data.model.IdDonneePere" (success)="RefreshGrid($event, modalSegmentation)"></q-search>
  </div>
</ng-template>


<!--#endregion modal -->
